module.exports = __webpack_public_path__ + "img/order-tab-pending-active.7b2e6d48.png";